import React from "react";
import { Auth0User, Auth0UserMetadata, Profile } from "../@types/data";
import { TvStudioStageState } from "../@types/generated/types";
import {
  STAGES_COMPONENTS,
  StudioStagesConfig
} from "../providers/stagesConfig";
import { VoiceControlsType } from "../stateManagement/types/studio.types";
import type { ProsodyTagsGenerationSupportedCombination } from "../utils/ProsodyTagsGeneration";

export interface InterfaceProfileContext {
  profile: Profile;
  hasRole: boolean;
  setProfile: React.Dispatch<React.SetStateAction<Profile | null>>;
  isAuthenticated: boolean;
  isLoading: boolean;
  isTokenLoading: boolean;
  authProvider: "auth0";
  token: React.MutableRefObject<string | undefined>;
  logout: () => void;
  refreshTokenCallback: () => Promise<void>;
  userData: Auth0User;
  updateUserMetadata: (updatedValue: Auth0UserMetadata) => void;
}

// @ts-ignore The provider sets the values, so we pass an empty object here
export const ProfileContext = React.createContext<InterfaceProfileContext>({});

export interface InterfaceSessionContext {
  heartbeatSuccess: boolean;
  totalTime: number | undefined;
  isIdle: boolean;
}

// @ts-ignore The provider sets the values, so we pass an empty object here
export const SessionContext = React.createContext<InterfaceSessionContext>({});

export type StudioStagesConfigObj = {
  config: StudioStagesConfig;
  isConfigLoading: boolean;
};

export interface StudioFeatureFlags {
  isNotesForVAEnabled: boolean;
  isProsodyTemplateServiceEnabled: boolean;
  shouldGenerateGroupInOGSevice: boolean;
  isGlossaryEnabled: boolean;
  isCompleteAllSegmentsButtonEnabled: boolean;
  isVideoNotesEnabled: boolean;
  isQaPerformanceEnabled: boolean;
  isTranslationMemorySearchEnabled: boolean;
  isMultipleRenditionsEnabled: boolean;
  isStudioStagesFlagEnabled: boolean;
  isProsodyBuffetEnabled: boolean;
  isProsodyTagsGenerationEnabled: boolean;
  prosodyTagsGenerationSupportedCombinations: ProsodyTagsGenerationSupportedCombination[];
  studioStagesConfig: StudioStagesConfigObj;
  areStudioCatToolsEnabled: boolean;
  isSessionTimeoutModalEnabled: boolean;
  isSpeakerNameMappingEnabled: boolean;
  isManualScrollSuspendsAutoScrollEnabled: boolean;
  isSegmentDeepLinkEnabled: boolean;
  isXlptControlsEnabled: boolean;
  xlptControls: VoiceControlsType[];
  speakerMapping: {
    [key: string]: string;
  };
}

export const StudioFeatureFlagContext = React.createContext<StudioFeatureFlags>(
  // @ts-ignore The provider sets the values, so we pass an empty object here
  {}
);

export type StagesProps = {
  isComponentInCurrStage: (
    componentId: (typeof STAGES_COMPONENTS)[number]
  ) => boolean;
  isStudioStagesEnabled: boolean;
  currTvStudioStage: TvStudioStageState;
  nextStage: TvStudioStageState | null;
};

// @ts-ignore The provider sets the values, so we pass an empty object here
export const StagesContext = React.createContext<StagesProps>({});

export interface ActivitiesContextProps {
  currYearAndMonth: string; // Format: YYYY-MM
  setCurrYearAndMonth: React.Dispatch<React.SetStateAction<string>>;
}

export const ActivitiesContext = React.createContext<ActivitiesContextProps>(
  // @ts-ignore The provider sets the values, so we pass an empty object here
  {}
);
